import { render, staticRenderFns } from "./Akkordeon.vue?vue&type=template&id=89903a38&scoped=true&"
import script from "./Akkordeon.vue?vue&type=script&lang=js&"
export * from "./Akkordeon.vue?vue&type=script&lang=js&"
import style0 from "./Akkordeon.vue?vue&type=style&index=0&id=89903a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89903a38",
  null
  
)

export default component.exports